var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDocumentGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 8.96875C10.375 8.75781 10.1641 8.54688 9.95312 8.54688H4.04688C3.80078 8.54688 3.625 8.75781 3.625 8.96875V9.95312C3.625 10.1992 3.80078 10.375 4.04688 10.375H9.95312C10.1641 10.375 10.375 10.1992 10.375 9.95312V8.96875ZM9.95312 11.5H4.04688C3.80078 11.5 3.625 11.7109 3.625 11.9219V12.9062C3.625 13.1523 3.80078 13.3281 4.04688 13.3281H9.95312C10.1641 13.3281 10.375 13.1523 10.375 12.9062V11.9219C10.375 11.7109 10.1641 11.5 9.95312 11.5ZM13.75 4.89062C13.75 4.46875 13.5391 4.01172 13.2227 3.69531L10.3047 0.777344C9.98828 0.460938 9.53125 0.25 9.10938 0.25H1.9375C0.988281 0.25 0.25 1.02344 0.25 1.9375V16.5625C0.25 17.5117 0.988281 18.25 1.9375 18.25H12.0625C12.9766 18.25 13.75 17.5117 13.75 16.5625V4.89062ZM9.25 2.07812L11.9219 4.75H9.25V2.07812ZM12.0625 16.5625H1.9375V1.9375H7.5625V5.59375C7.5625 6.08594 7.91406 6.4375 8.40625 6.4375H12.0625V16.5625Z",
    fill: "#199690"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentGreen);
export default __webpack_public_path__ + "static/media/ic-document-green.860eecb97fd2887a2454cda1fec4f723.svg";
export { ForwardRef as ReactComponent };